module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pa-5 pt-0 pb-0"
  }, [_c('v-row', {
    staticStyle: {
      "justify-content": "between"
    }
  }, [_c('v-col', {
    staticClass: "sub-title",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("Drafts")]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "mt-0",
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedFilter.search),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "search", $$v)
      },
      expression: "selectedFilter.search"
    }
  })], 1), _vm._v(" "), (_vm.isSuperAdmin || _vm.isAM) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "name",
      "label": "AM",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSuperAdmin || _vm.isCC) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": "name",
      "label": "CC",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.CC),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CC", $$v)
      },
      expression: "selectedFilter.CC"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-data-table', {
    staticClass: "drafts-data-table elevation-1",
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "search": _vm.selectedFilter.search,
      "items-per-page": 5
    },
    scopedSlots: _vm._u([{
      key: "item.timeline",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [(_vm.isLinkAllow) ? _c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": ("/campaigns/timeline?campaignID=" + (item.campaignID)),
            "target": '_blank'
          }
        }, [_vm._v("\n            " + _vm._s(item.startDate || '') + " - " + _vm._s(item.endDate || '') + "\n          ")]) : _c('span', [_vm._v(_vm._s(item.startDate || '') + " - " + _vm._s(item.endDate || ''))])])]
      }
    }, {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-left " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": ("/influencers/invoices-brief-confirmation?id=" + (item.campaignID)),
            "target": '_blank'
          }
        }, [_vm._v(_vm._s(item.name || ''))])])]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": '/posts/internal/all-posts?campaignID=' + item.campaignID,
            "target": "_blank"
          }
        }, [_vm._v("\n            " + _vm._s(item.producedDeliverables || 0) + " / " + _vm._s(item.pairingDeliverables || 0) + "\n          ")])])]
      }
    }, {
      key: "item.submissionDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('span', [_vm._v(_vm._s(item.submissionDate ? _vm.formatDate(item.submissionDate) : ''))])])]
      }
    }, {
      key: "item.reviewDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center pt-2 pb-2 " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('div', {
          staticClass: "d-flex flex-row",
          staticStyle: {
            "justify-content": "center"
          }
        }, [_c('v-text-field', {
          staticClass: "edit-date-box",
          attrs: {
            "placeholder": "Review Date",
            "outlined": "",
            "dense": "",
            "hide-details": ""
          },
          on: {
            "input": function($event) {
              return _vm.checkDate(item, 'reviewDate', 'validReviewDate')
            },
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.checkDate(item, 'reviewDate', 'validReviewDate', true)
            }
          },
          model: {
            value: (item.reviewDate),
            callback: function($$v) {
              _vm.$set(item, "reviewDate", $$v)
            },
            expression: "item.reviewDate"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "date-picker-inner"
        }, [_c('date-picker', {
          attrs: {
            "className": "input-field",
            "options": {
              theme: 'icon',
              confirm: true
            },
            "status": item.reviewDateCal
          },
          on: {
            "changeDate": function($event) {
              var i = arguments.length, argsArray = Array(i);
              while ( i-- ) argsArray[i] = arguments[i];

              return _vm.setDateFromPicker.apply(void 0, [ item, 'reviewDate' ].concat( argsArray ))
            }
          }
        })], 1)], 1), _vm._v(" "), (item.validReviewDate === false) ? _c('div', [_c('span', {
          staticClass: "text-danger ma-0 pt-1"
        }, [_vm._v("Invalid Start Date")])]) : _vm._e()])]
      }
    }], null, true)
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7175e11a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/DraftsDataTable.vue
// module id = 2190
// module chunks = 0